export default {
	ninzhidexinlande: 'Your trusted travel companion',
	zainalizhaodaonixiangyao: 'Find Cheap Flights You Want Where To?',
	zhaodaoyitiaoshihenideluxian: 'Find a route that matches you',
	zuijindedijiajipiao: 'Recent low price airline tickets',
	qingshuruhuoxuanzenidechengshi: 'Please enter or select your destination!',
	wodeyuding: 'My Booking',
	kehuzhiyuan: 'Help',
	denglu: 'Login',
	suoyouhangban: 'All Airports',
	baokuoshuifei: 'Tax & Charges Included',
	baokuotuoyunxingli: 'Includes checked baggage',
	yingwen: 'English',
	zhongzhuan: 'Transit',
	shijian: 'Time',
	gangbi: 'HKD',
	yuyan: 'Language',
	bizhong: 'Currency',
	jipiao: 'AIR',
	xuesheng: 'STUDENT',
	guyong: 'DOMESTIC HELPER',
	haiyuan: 'SEAMAN',
	lvxingtuan: '',
	zuche: 'CAR RENTAL',
	nianling: 'age',
	sui: 'years',
	laihui: 'Return',
	dancheng: 'One Way',
	duogemudidi: 'Multi-City',
	you: 'From',
	dao: 'To',
	chufashijian: 'Departing',
	fanchengshijian: 'Returning',
	lvke: 'Traveller',
	toudengcang: 'First Class',
	cangdeng: 'Cabin Class',
	jingjicang: 'Economy Class',
	shangwucang: 'Business Class',
	gaojijingjicang: 'Premium Economy',
	souxun: 'Search',
	remenyouhui: 'Hotdeals',
	remenjingdian: 'Top Destination',
	chengren: 'Adult',
	xiaotong: 'Child',
	yinger: 'Infant',
	souxunhangban: 'Searching for flights',
	liaojiegengduo: 'Learn more',
	guanyu: 'About',
	guanyuwomen: 'About Us',
	lianluowomen: 'Contact Us',
	fukuan: 'Payment',
	tiaokuanyuxize: 'Terms & Conditions',
	yinsizhengce: 'Privacy Policy',
	fuwu: 'Services',
	hangban: 'AIR',
	jiudian: 'Hotels',
	xueshengjipiao: 'Student Ticket',
	guyongjipiao: 'Domestic Helper',
	haiyuanjipiao: 'Seamen',
	changjianwenti: 'FAQ',
	dingyueyoujian: 'Subscribe to email',
	nideyoujian: 'Your Email',
	qingshuru: 'Please Enter ',
	womenjieshou: 'We accept',
	paixushaixuan: 'sort&filter',
	remenhangbanyouhui: 'Popular Flights Deals',
	chengshi: 'city',
	yaozuodeshiqing: 'Attractions',
	huodong: 'Activities',
	ranggoupiaogengrongyi: "Taro-Trip adheres to the concept of 'making buying tickets easier', provides users with high-quality online ticket sales services, provides convenience for customers' travel, and contributes to tourism and economic development.",
	banquansuoyou: 'All rights reserved',
	xiangtongchengshitishi: 'The departure city and destination city cannot be the same',
};
